// IMPORTS
// Modules
import { useRef, useLayoutEffect, useState } from 'react';
import $ from 'jquery';
// Assets
import './../scss/OHSLoading.scss';
import image_loadingwheel from './../images/loading_wheel.png';


// COMPONENT
export default function OHSLoading (props) {
   // States and Variables
   const image = useRef(null);
   const [spinner, setSpinner] = useState(null);

   // On-load
   useLayoutEffect(function () {
      if (props.toggle) {
         spin();
      } else {
         clearInterval(spinner);
      }
   }, [props.toggle]);

   // Functions
   const spin = function () {
      var angle = 0;
      setSpinner(setInterval(function () {
         $(image.current).css('transform', 'rotate(' + angle + 'deg)');
         angle += 1;
      }, 7));
   }

   // Component
   return (
      <>
         {props.toggle &&
            <div className='ohsloading'>
               <div className='ohsloading-content'>
                  <img ref={image} src={image_loadingwheel} />
                  <p>Loading, please wait...</p>
               </div>
            </div>
         }
      </>
   );
}